import styled from 'styled-components';

export const StyledIndustriesList = styled.section`
    padding: 120px 0 120px;
    position: relative;

    .masonary-row {
        margin-top: 60px;

        @media (max-width: 767px) {
            margin-top: 0;
        }
    }

    .col-md-3 {
        padding-bottom: 30px;

        @media (max-width: 767px) {
            padding-bottom: 0;
            margin-bottom: 30px;
            max-width: 50%;
            flex: 0 0 50%;

            &:nth-of-type(4n-2) {
                transform: translateY(0) !important;
            }

            &:nth-of-type(4n-1) {
                transform: translateY(0) !important;
            }
        }

        &:nth-of-type(4n-2) {
            transform: translateY(50px);
        }

        &:nth-of-type(4n-1) {
            transform: translateY(20px);
        }
    }
`;
